import { authHeader } from '../helpers/auth-header';

const fetchBoardsType = 'FETCH_BOARDS';
const getBoardsType = 'GET_BOARDS';
const postBoardType = 'POST_BOARD';
const getBoardType = 'GET_BOARD';
const putBoardType = 'PUT_BOARD';
const deleteBoardType = 'DELETE_BOARD';
const checkBoardType = 'CHECK_BOARD';

const initialState = { boards: [], board: null, isLoading: false };

export const boardsActions = {

    getBoards: (c, s) => async (dispatch, getState) => {
        dispatch({ type: fetchBoardsType });
        const response = await fetch(`api/boards?c=${c}&s=${s}`, { headers: authHeader() });
        const boards = await response.json();
        dispatch({ type: getBoardsType, boards });
    },

    getDictionary: (c, s, p) => async (dispatch, getState) => {
        let params = `c=${c}&s=${s}`;
        if (p === undefined) {
            let search = new URLSearchParams(window.location.search);
            //if (search.get('p') !== undefined) params = params + `&p=` + (Number(search.get('p')) + 1);
            if (search.get('p') !== undefined) params = params + `&p=1`;
        } else {
            params = params + `&p=${p}`;
        }
        const response = await fetch(`api/boards/dictionary?${params}`);
        const boards = await response.json();
        dispatch({ type: getBoardsType, boards });
    },

    getSearch: (q, e) => async (dispatch, getState) => {
        let params = `&q=${q}`;
        if (e !== undefined) params = params + `&e=${e}`;

        const response = await fetch(`api/boards/search?${params}`);
        const boards = await response.json();
        dispatch({ type: getBoardsType, boards });
    },

    postBoard: board => async (dispatch, getState) => {
        var formData = new FormData();
        for (let key in board) {
            if (key === 'types') continue;
            if (key !== 'formFiles') {
                //console.log(key + " : " + board[key])
                formData.append(key, board[key]);
            } else {
                for (let i = 0; i < board[key].length; i++) {
                    formData.append(key, board[key][i]);
                    formData.append('types', board[key][i].typeOfStorage)
                }
            }
        }
        await fetch(`api/boards`, {
            method: 'POST',
            headers: authHeader(),
            body: formData
        })
    },

    getBoard: id => async (dispatch, getState) => {
        // Don't issue a duplicate request (we already have or are loading the requested data)
        if (getState().boards.board !== null && (id === getState().boards.board.board.boardId.toString())) return;
        const response = await fetch(`api/boards/${id}`);
        const board = await response.json();
        dispatch({ type: getBoardType, board });
    },

    putBoard: (id, board) => async (dispatch, getState) => {
        var formData = new FormData();
        for (let key in board) {
            if (key === 'types') continue;

            if (key !== 'formFiles') formData.append(key, board[key]);
            else {
                for (let i = 0; i < board[key].length; i++) {
                    formData.append(key, board[key][i]);
                    formData.append('types', board[key][i].typeOfStorage)
                }
            }
        }
        await fetch(`api/boards/${id}`, {
            method: 'PUT',
            headers: authHeader(),
            body: formData
        })
    },

    deleteBoard: boardId => async (dispatch, getState) => {
        dispatch({ type: fetchBoardsType });
        const response = await fetch(`api/boards/${boardId}` , {
            method: 'DELETE',
            headers: authHeader(),
        })
        boardId = await response.json();
        dispatch({ type: deleteBoardType, boardId });
    },

    checkBoard: (name, id) => async (dispatch, getState) => {
        dispatch({ type: fetchBoardsType });
        const response = await fetch(`api/boards/checkbox/${name}/${id}`, {
            method: 'PUT',
            headers: 
                //'Content-Type': 'application/json',
                authHeader()
            
        })
        const board = await response.json();
        dispatch({ type: checkBoardType, board });
    },

};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case fetchBoardsType:
            return { ...state, isLoading: true };

        case getBoardsType:
            return { ...state, boards: action.boards, isLoading: false };

        case postBoardType:
            return { ...state, board: action.board };

        case getBoardType:
            return { ...state, board: action.board };

        case putBoardType:
            return { ...state, boardId: action.boardId, board: action.board };

        case deleteBoardType:
            return { ...state, boards: state.boards.filter(board => board.boardId !== action.boardId), isLoading: false };

        case checkBoardType:
            let { boards } = state;
            for (let i = 0; i < boards.length; i++) {
                let board = boards[i];
                if (board.boardId === action.board.boardId) {
                    //console.log(action.board.boardId +" : " + action.board.enabled + " : " + action.board.fixed);
                    boards[i].enabled = action.board.enabled;
                    boards[i].fixed = action.board.fixed;
                    boards[i].finished = action.board.finished;
                }
            }
            return { ...state, boards: boards, isLoading: false };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/boards.js